import React from 'react';
import { Sale } from '../types/types';
import './Receipt.css';

interface ReceiptProps {
    sale: Sale;
    storeConfig: any;
}

export const Receipt: React.FC<ReceiptProps> = ({ sale, storeConfig }) => {
    const formatDate = (date: Date) => {
        return new Date(date).toLocaleString('es-DO');
    };

    const formatCurrency = (amount: number) => {
        // Correctly handle currency symbol manually to avoid 'Invalid currency code' error
        // if the symbol in database is '$' instead of 'USD'/'DOP'.
        const symbol = storeConfig?.currencySymbol || '$';

        // Use 'decimal' style instead of 'currency' to safely format the number
        const formattedAmount = new Intl.NumberFormat('es-DO', {
            style: 'decimal',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(amount);

        return `${symbol}${formattedAmount}`;
    };

    return (
        <div id="receipt-content" className="receipt-container">
            <div className="receipt-header">
                <h2>{storeConfig?.storeName || 'POS System'}</h2>
                {storeConfig?.address && <p>{storeConfig.address}</p>}
                {storeConfig?.phone && <p>Tel: {storeConfig.phone}</p>}
                {storeConfig?.email && <p>{storeConfig.email}</p>}
                {storeConfig?.receiptHeader && <p className="custom-header">{storeConfig.receiptHeader}</p>}
                <div className="receipt-meta">
                    <p><strong>Fecha:</strong> {formatDate(sale.saleDate)}</p>
                    <p><strong>Orden #:</strong> {sale.id.toString().padStart(6, '0')}</p>
                    <p><strong>Cajero:</strong> {sale.user?.username || 'N/A'}</p>
                    {sale.customer && <p><strong>Cliente:</strong> {sale.customer.name} {sale.customer.lastName}</p>}
                </div>
            </div>

            <div className="receipt-divider">--------------------------------</div>

            <table className="receipt-items">
                <thead>
                    <tr>
                        <th className="qty-col">Cant</th>
                        <th className="item-col">Desc</th>
                        <th className="price-col">Total</th>
                    </tr>
                </thead>
                <tbody>
                    {sale.saleItems.map((item) => (
                        <tr key={item.id}>
                            <td>{item.quantity}</td>
                            <td>{item.product?.name}</td>
                            <td className="text-right">{formatCurrency(item.quantity * item.unitPrice)}</td>
                        </tr>
                    ))}
                </tbody>
            </table>

            <div className="receipt-divider">--------------------------------</div>

            <div className="receipt-totals">
                <div className="total-row large">
                    <span>TOTAL</span>
                    <span>{formatCurrency(sale.totalAmount)}</span>
                </div>
            </div>

            <div className="receipt-payment-info">
                <p>Método de Pago: {sale.payments[0]?.paymentMethod?.name || 'Contado'}</p>
                {sale.payments[0]?.bankName && (
                    <p>Banco: {sale.payments[0].bankName}</p>
                )}
                {sale.payments[0]?.transferReference && (
                    <p>Ref: {sale.payments[0].transferReference}</p>
                )}
            </div>

            <div className="receipt-footer">
                {storeConfig?.receiptFooter && <p>{storeConfig.receiptFooter}</p>}
                <p>¡Gracias por su compra!</p>
            </div>
        </div>
    );
};
